import React, {useEffect, useState} from 'react';
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import {Link} from "react-router-dom";
import RepresentativesService from "../../../services/RepresentativesService";
import Spinner from 'reactjs-simple-spinner';
import {toast, ToastContainer} from "react-toastify";
import isEmail from "validator/lib/isEmail";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Select from "@material-ui/core/Select";


const EditRepresentative = (props) => {

    const [rep, setRep] = useState({});
    const [loading, setLoading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(false);

    const initialUser = {
        representativeId: JSON.parse(localStorage.getItem('representativeId')),
        employerId: JSON.parse(localStorage.getItem('employerId'))
    }

    const [name, setName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [contactNumber, setContactNumber] = useState('');
    const [category, setCategory] = useState('');
    const [categories, setCategories] = useState([])
    const [error, setError] = useState(false);
    //input error message
    const [nameError, setNameError] = useState(false);
    const [nameErrorMsg, setNameErrorMsg] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [emailErrorMsg, setEmailErrorMsg] = useState('');
    const [contactError, setContactError] = useState(false);
    const [contactErrorMsg, setContactErrorMsg] = useState('');
    const [lastNameError, setLastNameError] = useState(false);
    const [lastNameErrorMsg, setLastNameErrorMsg] = useState('');
    const [categoryError, setCategoryError] = useState(false);
    const [categoryErrorMsg, setCategoryErrorMsg] = useState('');

    const [user, setUser] = useState(initialUser);
    useEffect(() => {
        setInitialLoading(true);
        const id = JSON.parse(localStorage.getItem('representativeId'));
        console.log(id);
        RepresentativesService.getAllCategories().then(response => {
            let categories = response;
            setCategories(categories);
        }).catch(err => {
            console.log(err);
        });
        RepresentativesService.getRepresentativeDetails(id).then(response => {
            console.log(response);
            setUser(response.representative);
            setName(response.representative.first_name)
            setLastName(response.representative.last_name)
            setEmail(response.representative.email)
            setContactNumber(response.representative.contact_number)
            setCategory(response.representative.category_name);
            setInitialLoading(false);
        }).catch(err => {
            console.log(err);
            setInitialLoading(false);
            toast.warning('Operation Failed, Reload Page\nIf error persists contact System Administrator ')
        });

    }, []);

    const handleUpdate = (e) => {
        e.preventDefault();
        if (name === '') {
            setNameError(true)
            setNameErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (lastName === '') {
            setLastNameError(true)
            setLastNameErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (email === '') {
            setEmailError(true)
            setEmailErrorMsg('Field is required')
            setError(true);
            return;
        }
        if (!isEmail(email)) {
            setEmailError(true)
            setEmailErrorMsg('Email not valid')
            setError(true);
            return;
        }
        if (contactNumber === '') {
            setContactError(true)
            setContactErrorMsg('Contact is required')
            setError(true);
            return;
        }
        if (contactNumber.length < 9) {
            setContactError(true)
            setContactErrorMsg('Mobile number must be a 9 digit number')
            return;
        }
        if (category === '') {
            setCategoryError(true)
            setCategoryErrorMsg('Field is required')
            setError(true);
            return;
        }
        setLoading(true);
        //reset error messages
        setError(false)
        setEmailError(false);
        setNameError(false);
        setLastNameError(false);
        setContactError(false);
        setCategoryError(false)
        //call update endpoint
        let data = {
            'first_name': name,
            'last_name': lastName,
            'employerId': user.employerId,
            'representativeId': user.representativeId,
            'contact_number': contactNumber,
            'email': email,
            'category_name': category
        }
        console.log("user: ", data);
        RepresentativesService.updateRepresentative(user.id, data)
            .then(res => {
                if (res.status === 200) {
                    setUser(res.data);
                    setLoading(false);
                    toast('Representative Updated Successfully', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    console.log(res);
                } else {
                    setLoading(false);
                    toast.warning('Operation Failed, Error: ' + res, {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            })
            .catch(err => {
                toast.warning('Operation Failed, Error: ' + err, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                console.log(err);
            })

    }


    const handleChangeName = (e) => {
        if (e.target.value === '') {
            setNameError(true)
            setNameErrorMsg('Field is required')
        } else {
            setNameError(false);
            setNameErrorMsg('')
        }
        console.log(e.target.value)
        setName(e.target.value);
    }
    const handleChangeLastName = (e) => {
        if (e.target.value === '') {
            setLastNameError(true)
            setLastNameErrorMsg('Field is required')
        } else {
            setLastNameError(false);
            setLastNameErrorMsg('')
        }
        console.log(e.target.value)
        setLastName(e.target.value);
    }
    const handleChangeEmail = (e) => {
        if (e.target.value === '') {
            setEmailError(true)
            setEmailErrorMsg('Field is required')
        } else {
            setEmailError(false)
            setEmailErrorMsg('')
        }
        if (isEmail(e.target.value) === false) {
            setEmailError(true)
            setEmailErrorMsg('Email not valid')
        } else {
            setEmailError(false)
            setEmailErrorMsg('')
        }
        console.log(e.target.value)
        setEmail(e.target.value)
    }
    const handleChangeContactNumber = (e) => {
        if (e.target.value === '') {
            setContactError(true)
            setContactErrorMsg('Field is required')
        } else {
            setContactError(false)
            setContactErrorMsg('')
        }
        if (e.target.value.length < 9) {
            setContactError(true)
            setContactErrorMsg('Mobile number must be a 9 digit number')
        } else {
            setContactError(false)
            setContactErrorMsg('')
        }
        console.log(e.target.value)
        setContactNumber(e.target.value);
    }
    const handleChangeCategory = (e) => {
        console.log(e.target.value)
        setCategory(e.target.value);
    }

    return (
        <div>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            {initialLoading && (
                <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                    <Spinner
                        size="large"
                        message="Loading Information..."
                        line-fg-color="#64c3c2"
                    />
                </div>
            )}
            {!initialLoading && (
                <div id="main-content" className="main-panel ps-container ps-theme-default">
                  <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>

                    <div className="content">
                        <div className="container-fluid">
                            <ul className="breadcrumb">
                                <Link to="/dashboard">
                                    <i className="fa fa-home"/>&nbsp;Dashboard
                                </Link>
                                &nbsp;|&nbsp;
                                <Link to="/representatives">
                                    <a href> Representatives </a>
                                </Link>   &nbsp;|&nbsp;
                                Edit Representative
                            </ul>
                        {loading && (
                            <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                <Spinner
                                    size="medium"
                                    message="Updating Representative,Please wait....."
                                    line-fg-color="#64c3c2"
                                />
                            </div>

                        )}
                        {!loading && (
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="card">
                                        {/*    edit form*/}
                                        <form id="employerData" onSubmit={handleUpdate}>
                                            <div id="form-style">
                                                <div className="form-row">
                                                    <div className="form-group col-md-4">

                                                        <TextField
                                                            error={nameError}
                                                            helperText={nameErrorMsg}
                                                            required
                                                            autoFocus
                                                            margin="dense"
                                                            label="FirstName"
                                                            type="text"
                                                            fullWidth
                                                            value={name}
                                                            inputProps={{style: {textTransform: 'capitalize'}}}
                                                            onChange={handleChangeName}
                                                        />
                                                    </div>

                                                    <div className="form-group col-md-4">
                                                        <TextField
                                                            error={lastNameError}
                                                            helperText={lastNameErrorMsg}
                                                            required
                                                            margin="dense"
                                                            label="LastName"
                                                            type="text"
                                                            fullWidth
                                                            value={lastName}
                                                            inputProps={{style: {textTransform: 'capitalize'}}}
                                                            onChange={handleChangeLastName}
                                                        />
                                                    </div>

                                                    <div className="form-group col-md-4">
                                                        <TextField
                                                            error={emailError}
                                                            helperText={emailErrorMsg}
                                                            required
                                                            margin="dense"
                                                            label="Email"
                                                            type="email"
                                                            fullWidth
                                                            inputProps={{style: {textTransform: 'lowercase'}}}
                                                            value={email}
                                                            onChange={handleChangeEmail}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="form-row">
                                                    <div className="form-group col-md-6" style={{marginTop: 22}}>
                                                        <TextField
                                                            error={contactError}
                                                            helperText={contactErrorMsg}
                                                            required
                                                            margin="dense"
                                                            label="Contact Number"
                                                            type="number"
                                                            fullWidth
                                                            value={contactNumber}
                                                            onChange={handleChangeContactNumber}
                                                            onInput={(e) => {
                                                                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 9)
                                                            }}
                                                            InputProps={{
                                                                startAdornment: <InputAdornment position="start">
                                                                    +263
                                                                </InputAdornment>
                                                            }}
                                                        />
                                                    </div>

                                                    <div className="form-group col-md-6">
                                                        <label>Designation: <b>{category}</b></label>
                                                        <Select className="form-control" onChange={handleChangeCategory}
                                                                name="category">
                                                            <option>Select Category</option>
                                                            {categories.map((category, i) => {
                                                                return (
                                                                    <option key={i} value={category.categoryTitle}>
                                                                        {category.categoryTitle}
                                                                    </option>
                                                                )
                                                            })}
                                                        </Select>
                                                        {categoryError && (
                                                            <span className="text-danger">{categoryErrorMsg}</span>
                                                        )}
                                                        <br/>
                                                    </div>
                                                </div>
                                                <div className="form-row">
                                                    <div className="form-group col-md-12">
                                                        <Link to="/representatives">
                                                            <button className="btn btn-info btn-sm">
                                                                <i className="fa fa-backward"/>&nbsp;&nbsp;Back
                                                            </button>
                                                        </Link>
                                                        <button
                                                            onClick={handleUpdate}
                                                            id="editRepresentative"
                                                            className="btn btn-success btn-sm ld-ext-right"
                                                        >
                                                            Update
                                                            <div className="ld ldld bare"
                                                                 style={{width: 10, height: 10}}/>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        )}

                        </div>
                    </div>
                </div>
            )}
        </div>

    )
}

export default EditRepresentative;
